<div class="container">
  <div class="header">
    <img class="logo pointer" src="assets/images/logo.png" alt="logo" [routerLink]="['/join']" />
    <a  href="mailto:support@proxdis.com">support@proxdis.com</a>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>